const RESERVED_TENANT_SUBDOMAINS = new Set(["app", "www"]);

const TENANT_ROOT_DOMAIN = "forgehq.io";

function normalizeHost(hostname: string): string {
  return hostname.trim().toLowerCase().replace(/:\d+$/, "");
}

function isValidTenantSlug(slug: string): boolean {
  return /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(slug);
}

export function getTenantSlugFromHost(hostname: string): string | null {
  const normalizedHost = normalizeHost(hostname);
  const match = normalizedHost.match(
    new RegExp(`^([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\\.${TENANT_ROOT_DOMAIN}$`),
  );

  if (!match) {
    return null;
  }

  const slug = match[1];

  if (!isValidTenantSlug(slug) || RESERVED_TENANT_SUBDOMAINS.has(slug)) {
    return null;
  }

  return slug;
}

export function isTenantHost(hostname: string): boolean {
  return getTenantSlugFromHost(hostname) !== null;
}

export function buildTenantAppUrlFromSlug(slug: string): string {
  const normalizedSlug = slug.trim().toLowerCase();
  if (!isValidTenantSlug(normalizedSlug) || RESERVED_TENANT_SUBDOMAINS.has(normalizedSlug)) {
    throw new Error(`Invalid organization slug: ${slug}`);
  }

  return `https://${normalizedSlug}.${TENANT_ROOT_DOMAIN}`;
}
